'use strict';

exports.Address4 = require('./lib/ipv4.js');
exports.Address6 = require('./lib/ipv6.js');

exports.v6 = {
  helpers: require('./lib/v6/helpers.js')
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ip-address/ip-address.js
// module id = 647
// module chunks = 0